import { WorldTennisNumberTypeEnum } from 'types/api/enums'
import { createWorldTennisNumberHistoryRating, wtnHistoryDefaultData } from './getRantings'

export const getEarliestRatings = (data?: (typeof wtnHistoryDefaultData)[]) => ({
  worldTennisNumberHistory: {
    items: data || [
      createWorldTennisNumberHistoryRating(),
      createWorldTennisNumberHistoryRating({ type: WorldTennisNumberTypeEnum.DOUBLE }),
    ],
    __typename: 'WorldTennisNumberList',
  },
})
